module.exports = __webpack_public_path__ + "img/06_full.c4705dd6.jpg";